"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _radioButton = _interopRequireDefault(require("@ingka/radio-button"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RadioButtonGroup = props => {
  const {
    className,
    describedById,
    list,
    name,
    prefix = '',
    subtle = false,
    ...other
  } = props;
  const classes = (0, _classnames.default)(`${prefix}radio-button-group`, className);
  return _react.default.createElement("fieldset", _extends({
    role: "radiogroup",
    className: classes
  }, other), name && _react.default.createElement("legend", null, name), list.map((item, i) => {
    return _react.default.createElement(_radioButton.default, _extends({
      key: i
    }, item, {
      prefix: prefix,
      subtle: subtle
    }));
  }));
};
var _default = RadioButtonGroup;
exports.default = _default;